import React from 'react';

// eslint-disable-next-line react/prop-types
export default ({ key, children }) => (<React.Fragment key={key}>{children}</React.Fragment>);
